export const SEARCH_PARAM = {
  PAGE_SIZE: 16,
};
